module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2AQMAAAC2i/ieAAAABlBMVEVHcEwiIiLWMREbAAAAAXRSTlMAQObYZgAAABVJREFUGNNjYBjiQP4/CDwgmh7iAAA3gCPdPcYZnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/ico_evoucher_minus_on.png
// module id = +niy
// module chunks = 0